define('source/source',['jquery'], function ($) {
	
	/**
	 * Default source for retrieving data
	 */
	var Source = function (defs) {
		this.options = $.extend({
			url : '',
			index : 'id'
		}, defs);
		
		this.isPending = false;
	};

	Source.prototype.retrieve = function (data, callback) {
		if(this.isPending) return;
		
		var $this = this;
		this.isPending = true;
		
		$.get($.url(this.options.url, data), function (result) {
			callback.call(this, result);
			
			$this.isPending = false;
		});
	};
	
	return Source;
	
});
